import { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeQty, removeFromCart } from "../../../redux";
import { LangContext } from "../../../context/LangContext";

import "./style.css";

function Cart({ setModal }) {
    const dispatch = useDispatch();
    const cart = useSelector(state => state.cart);
    const { language, translations } = useContext(LangContext);

    // Remove item from cart
    const handleRemove = (title_path, category_fr) =>
        dispatch(removeFromCart({ title_path, category_fr }));

    // Update quantity from cart
    const handleQty = (title_path, category_fr, q) => {
        const qty = parseInt(q, 10);
        if (qty < 1) return handleRemove(title_path, category_fr);
        dispatch(changeQty({ title_path, category_fr, qty }));
    };

    const total = cart.reduce((s, i) => s + i.price * i.quantity, 0);

    return (
        <form 
            className="content cart" 
            onSubmit={e => e.preventDefault()}
        >
            <p className="title_mdl">{translations.cart}</p>

            {cart.length === 0 && (
                <ul className="empty_cart">
                    <li><p>{translations.empty_cart}</p></li>
                </ul>
            )}

            {cart.length !== 0 && (
                <div className="list">
                    <ul className="cart_list">
                        {cart.map((item, idx) => (
                            <li key={idx} className={item.exist ? "cart_item" : "cart_item_inexist"}>
                                <div className="left">
                                    <i
                                        className="preview"
                                        style={{ backgroundImage: `url(${item.image._url})` }}
                                    />

                                    <div className="details">
                                        <p className="name">{item[`title_${language}`]}</p>

                                        {item.exist && item[`category_${language}`] && 
                                            <p className="cat">{item[`category_${language}`]}</p>
                                        }

                                        {!item.exist && <p className="cat">Out stock</p>}
                                        
                                        <p className="price">{item.price.toFixed(2)} €</p>
                                    </div>
                                </div>

                                <div className="right">
                                    <div className="qty_changer">
                                        <button
                                            type="button"
                                            onClick={() => handleQty(item.title_path, item.category_fr, item.quantity - 1)}
                                        >–</button>

                                        <input type="number" value={item.quantity} readOnly />

                                        <button
                                            type="button"
                                            onClick={() => handleQty(item.title_path, item.category_fr, item.quantity + 1)}
                                        >+</button>
                                    </div>

                                    <button
                                        type="button"
                                        className="btn_remove"
                                        onClick={() => handleRemove(item.title_path, item.category_fr)}
                                    >
                                        <i className="fas fa-xmark" />
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>

                    <div className="total_line">
                        <span>Total</span>
                        <span>{total.toFixed(2)} €</span>
                    </div>
                </div>
            )}

            <div className="panel_modal">
                <button
                    type="button"
                    className="btn_close"
                    onClick={() => setModal(null)}
                >{translations.close}</button>

                <button
                    type="button"
                    disabled={cart.length === 0 || cart.find(prod => !prod.exist)}
                    className={cart.length ? "btn_submit" : "btn_submit_inactif"}
                    onClick={() => setModal("choose")}
                >
                    {translations.place_order}
                </button>
            </div>
        </form>
    );
}

export default Cart;